import * as yup from 'yup'

export const termsOfUseFormValidation = yup.object().shape({
    body: yup.string().required(),
  	body_english: yup.string().required(),
    body_spanish: yup.string().required()    
})
